import React from "react";

// NYG Projects official logo — uses the brand PNGs in /public/brand
// Aspect ratio of the source image is roughly 925:630 (≈ 1.47:1)
// `size` controls the rendered height in px.
// `tone` = 'cream' (for dark surfaces) or 'dark' (for light surfaces)
export default function Logo({ size = 56, tone = "cream", className = "" }) {
  const src =
    tone === "dark" ? "/brand/nyg-logo-dark.png" : "/brand/nyg-logo-cream.png";
  return (
    <img
      src={src}
      alt="NYG Projects"
      data-testid="nyg-logo"
      className={`block select-none ${className}`}
      style={{ height: `${size}px`, width: "auto" }}
      draggable={false}
    />
  );
}
